import moment from 'moment';

const formatTime = (timestamp: number): string =>
    moment(timestamp).format('DD-MM-YYYY');

export const getPeriod = (spendData: {
    'Period name': Record<string, number>;
}) => {
    const { 'Period name': periodNames } = spendData;

    if (!periodNames) {
        throw new Error('Period names not found');
    }

    const periodNamesKeys = Object.keys(periodNames);

    if (periodNamesKeys.length === 0) {
        throw new Error('Period names are empty');
    }

    const timestamps = Object.values(periodNames);

    if (timestamps.length === 0) {
        throw new Error('No timestamp values found');
    }

    const smallestTimestamp = Math.min(...timestamps);
    const largestTimestamp = Math.max(...timestamps);

    const startDate = formatTime(smallestTimestamp);
    const endDate = formatTime(largestTimestamp);

    return { startDate, endDate };
};
